import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  guestUserToken: {},
  guestUser: {},
  entityTypeLabelConfiguration: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/guest/vuex/index.js